import { render, staticRenderFns } from "./FeatureSheet.vue?vue&type=template&id=50383348&"
import script from "./FeatureSheet.vue?vue&type=script&lang=js&"
export * from "./FeatureSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports